<template>
  <ResponsiveModal
    background="white"
    @update:open="handleUpdateOpen"
    :open="props.open"
    :variant="'default'"
    :size="'full'"
    :side="'default'"
    :title="$t('components.assign_qr.title')"
    :confirmLabel="t('components.buttons.save')"
    :showCancel="false"
    :disableConfirm="disabled"
    @confirm="assign"
  >
    <template #tabs>
      <TabsWithSearch
        ref="searchRef"
        v-model="tab"
        v-model:query="query"
        variant="linkedToSelector"
        tabVariant="underline"
        size="xl"
        :fullWidth="maxSmall"
        class="bg-primary"
      >
        <Tab :label="$t('components.link_to_selector.type.spaces')" />
        <Tab :label="$t('components.link_to_selector.type.assets')" />
      </TabsWithSearch>
    </template>
    <template #content>
      <LinkToSelector
        v-model="selection"
        :tab="tab"
        :query="query"
        :searching="searchRef?.searching"
        :buildingId="buildingId"
        :buildings="buildings"
        :buildingIsSelectable="false"
        @clear:search="searchRef.closeSearch()"
      />
    </template>
  </ResponsiveModal>
</template>

<script setup>
// Import Vue Utilities
import { computed, ref, watch } from "vue";

// Import Utilities
import { useForm } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

// Import Components
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { LinkToSelector } from "@/SharedComponents/LinkToSelector";
import { TabsWithSearch, Tab } from "@/SharedComponents/Tabs";

// Import Composables
import { useBreakpoints } from "@/Composables/useBreakpoints";

// Emits
const emit = defineEmits(["close", "assign"]);

// Breakpoints
const { maxSmall } = useBreakpoints();

// Define Props
const props = defineProps({
  open: Boolean,
  buildingId: { type: String, required: false },
  buildings: { type: Array, required: false },
});

// Refs
const selection = ref(undefined);
const tab = ref(props.defaultTab);
const query = ref("");
const searchRef = ref(null);

// Form
const form = useForm({
  space: null,
});

// Translations
const { t } = useI18n();

// Computed Props
const disabled = computed(() => {
  return !selection.value?.children;
});

// Functions
const close = () => {
  emit("close");
};

const handleUpdateOpen = (value) => {
  if (!value) {
    close();
  }
};

const assign = () => {
  emit("assign", selection.value.children[0]);
};

// Watchers
watch(
  () => props.open,
  () => {
    form.reset();
  }
);
</script>
